// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['admin']


const DEFAULT_URL = '/equipamento'

const EquipBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Equipamento',
    to: 'equipamento'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'equipamento',
    component: () => import('@/views/Equipamentos/ListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Equipamentos',
      breadcrumb: EquipBreadCrumb
    }
  },
  {
    path: `${DEFAULT_URL}/novo`,
    name: 'equipamentoNovo',
    component: () => import('@/views/Equipamentos/FormPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Novo Equipamento',
      breadcrumb: [
        ...EquipBreadCrumb,
        {
          label: 'Novo Equipamento',
          to: 'equipamentoNovo'
        }
      ]
    }
  },
  {
    path: `${DEFAULT_URL}/:id/edit`,
    name: 'equipamentoEdit',
    component: () => import('@/views/Equipamentos/FormPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes',
      breadcrumb: [
        ...EquipBreadCrumb,
        {
          label: 'Novo Equipamento',
          to: 'equipamentoNovo'
        }
      ]
    }
  }
]
